import Vue from 'vue'
import Router from 'vue-router'

import Home from '@/pages/Home'
import OrderCreate from '@/pages/OrderCreate'
import OrderList from '@/pages/OrderList'
import Reorder from '@/pages/Reorder'
import OAuth2Callback from '@/pages/OAuth2Callback'
import NotFound from '@/pages/404'
import store from '@/store'
import Configuration from '@/utils/configuration'

Vue.use(Router)
const ifNotAuthenticated = (to, from, next) => {
  if (store.getters['cpAuth/currentUser']) {
    next()
    return
  }
  next('/')
}

const ifReorderEnabled = (to, from, next) => {
  if (Configuration.value('reorderFeatureIsEnabled') === 'true') {
    next()
    return
  }

  next('/')
}

const isAuthenticated = (to, from, next) => {
  if (store.getters['cpAuth/currentUser']) {
    next('/orders')
  } else {
    next()
  }
}

const router = new Router({
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home,
      beforeEnter: isAuthenticated
    },
    {
      path: '/orders',
      name: 'order_list',
      component: OrderList,
      beforeEnter: ifNotAuthenticated
    },
    {
      path: '/order/create',
      name: 'order_create',
      component: OrderCreate,
      beforeEnter: ifNotAuthenticated
    },
    {
      path: '/order/:reference',
      name: 'order_list_overview',
      component: OrderList,
      beforeEnter: ifNotAuthenticated
    },
    {
      path: '/orders/:reference',
      name: 'order_list_overview2',
      component: OrderList,
      beforeEnter: ifNotAuthenticated
    },
    {
      path: '/reorder/:reference',
      name: 'reorder',
      component: Reorder,
      beforeEnter: (to, from, next) => {
        ifNotAuthenticated(to, from, next)
        ifReorderEnabled(to, from, next)
      }
    },
    {
      path: '/oauth2-callback',
      name: 'oauth2-callback',
      component: OAuth2Callback
    },
    {
      path: '*',
      component: NotFound
    }
  ],
  mode: 'history',
  linkActiveClass: 'is-active'
})

router.beforeEach((to, from, next) => {
  next()
})

export default router
